import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import Sortable from "../../../../componets/Sortable";
import { reorderUsernameStyles } from "../../../../actions/mine_craft/usernameStylesActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.usernameStyles.reorderIds);
  const usernameStyles = useAppSelector(state => state.mineCraft.usernameStyles.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderUsernameStyles({ ids }));
  }

  return (
    <div className='v-usernameStyles-reorder'>
      <h6 className="v-content-label o-sm">Reorder</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            items={usernameStyles}
            titleKey='title'
          />
      }
    </div>
  )
}

export default Reorder;
